<template>
    <sticky top="5rem">
        <div class="summary bg-lightest darker relative border-light">
            <span class="circle"></span>
            <span class="circle"></span>

            <summary-header :tag="true"></summary-header>

            <div class="info">
                <date-and-time :reservation="getClonedReservation"></date-and-time>

                <table v-if="pricePerOrder" class="table bare">
                    <tr>
                        <td>{{ pricePerOrder.label }}</td>
                        <td>
                            <div v-if="product.includeTaxes">
                                {{ formatPrice(pricePerOrder.value - (pricePerOrder.value * product.tax * 0.01)) }}€
                            </div>
                            <div v-else>
                                {{ formatPrice(pricePerOrder.value) }}€
                            </div>
                        </td>
                    </tr>
                </table>
                <table v-else class="table bare">
                    <tr v-for="price in prices">
                        <td class="text-lowercase">
                            {{ price.quantity }}x {{ price.title }}
                        </td>
                        <td>
                            <div v-if="product.includeTaxes">
                                {{ formatPrice((price.value - (price.value * product.tax * 0.01)) * price.quantity) }}€
                            </div>
                            <div v-else>
                                {{ formatPrice(price.value * price.quantity) }}€
                            </div>
                        </td>
                    </tr>
                </table>

                <div class="mt-3" v-if="addedExtras">
                    <span class="bold">Extras</span>

                    <table class="table bare">
                        <tr v-for="extra in extras" v-if="extra.item.quantity > 0">
                            <td>
                                {{ extra.item.quantity }}x {{ extra.item.name }}</td>
                            <td>
                                <div v-if="extra.priceIncluded">
                                    -
                                </div>
                                <div v-else>
                                    <div v-if="extra.item.priceIncludeTaxes && extra.item.vatType != 0">
                                        {{ formatPrice((extra.item.priceTotal - (extra.item.priceTotal * extra.item.vatType * 0.01)) * extra.item.quantity) }}€
                                    </div>
                                    <div v-else>
                                        {{ formatPrice(extra.item.priceTotal * extra.item.quantity) }}€
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="mt-3" v-if="activeTransport">
                    <span class="bold">Transport</span>

                    <table class="table bare">
                        <tr>
                            <td>{{ 2 }}x Seats</td>
                            <td>{{ (10 * 2).toFixed(2) }}€</td>
                        </tr>
                    </table>
                </div>

                <div v-if="chosenPayment" class="my-3 fs-small">
                    {{ chosenPayment.description }}
                </div>

            </div>
        </div>

        <summary-totals :reservation="getClonedReservation" :product="product" :chosenDeposit="chosenDeposit" :chosenPayment="chosenPayment"></summary-totals>

        <div class="d-flex buttons">
            <button type="button" class="btn cancel wider" @click="cancelReservation">Cancel</button>
            <button type="button" class="btn ok wider ml-3" @click="saveAndPay" :disabled="!buttonEnabled">Save &amp; Pay</button>
        </div>
    </sticky>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Sticky from 'vue-sticky-position'
    import SummaryHeader from './SummaryHeader'
    import SummaryTotals from './SummaryTotals'
    import DateAndTime from '../DateAndTime'

    export default {
        created: function () {
            this.setCorrectPaymentType()
        },
        props: {
            editable: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                chosenPayment: null,
                chosenDeposit: null,
            }
        },
        asyncComputed: {
            
            async deposits() {
                try {
                    let response = await axios.get('/api/settings/GetDepositTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.chosenDeposit = response.data.find(d => this.product.deposit === d.id);

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getPeopleLabels',
                'getRequirePaymentOptions'
            ]),
            buttonEnabled: function() {
                const c = this.getClonedReservation.customer;

                return c.name && c.name !== '' &&
                       c.surname && c.surname !== '' &&
                       c.email && c.email !== '' &&
                       c.phone && c.phone !== '';
            },
            prices: function() {
                let prices = [];

                if (this.product.prices !== undefined) {
                    this.product.prices.forEach(price => {
                        if (price.quantity !== undefined && price.quantity > 0) {
                            let type = this.getPeopleLabels.find(i => i.id === price.audienceType);

                            if (type) {
                                prices.push({
                                    title: type.title,
                                    quantity: price.quantity,
                                    value: this.formatPrice(price.value),
                                    currency: price.currency
                                });
                            }
                        }
                    });
                }

                return prices;
            },
            pricePerOrder: function() {
                if (this.product.prices.length === 1 && this.product.prices[0].type === 1 && this.product.prices[0].audienceType === null) {
                    return {
                        label: 'Order price',
                        value: this.formatPrice(this.product.prices[0].value)
                    }
                }
            },
            addedExtras: function() {
                let added = false;

                this.extras.forEach(e => {
                    if (e.item.quantity > 0) {
                        added = true;
                    }
                });

                return added;
            },
            product: function() {
                return this.getClonedReservation.event.product;
            },
            extras: function() {
                return this.product.extras;
            },
            paymentValue: function() {
                return this.formatPrice(this.product.paymentValue) + '€';
            },
            activeTransport: function() {
                return (this.getClonedReservation.transport && this.getClonedReservation.transport.length > 0);
            },
        },
        methods: {
            ...mapActions([
                'updateClonedReservation',
                'addReservation',
                'openModal',
            ]),
            setCorrectPaymentType: function () {
                this.chosenDeposit = this.getRequirePaymentOptions.find(d => this.product.deposit === d.id);

            },
            saveAndPay: function() {
                this.openModal('ReservationPayment');
            },
            cancelReservation: function() {
                this.clearActiveReservation();

                this.$router.push({ name: 'reservations' });
            }
        },
        components: {
            SummaryHeader,
            SummaryTotals,
            DateAndTime,
            Sticky,
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .summary {
        padding: 1rem 1rem 2rem;
        border-width: 1px 1px 0;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;

        > h3 > span {
            color: $dark;
        }

        .border {
            position: absolute;
            top: 0.85rem;
            left: 0;
            width: 5px;
            height: 25px;
            border-top-right-radius: 5rem;
            border-bottom-right-radius: 5rem;
            background: $color-6;
        }

        .circle {
            position: absolute;
            bottom: 1.5rem;
            width: 11px;
            height: 15px;
            background: $background;
            border: 1px solid $light;
            z-index: 1;

            &:nth-child(even) {
                right: -2px;
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
                border-right-color: $background;
            }

            &:nth-child(odd) {
                left: -2px;
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
                border-left-color: $background;
            }
        }
    }

    .buttons {
        > button {
            flex: 50%;
            padding-left: 1rem;
            padding-right: 1rem;
        }
    }

</style>



// WEBPACK FOOTER //
// Summary.vue?ecaf06bc